import React, { Component } from 'react';
import classnames from 'classnames';
import i18n from './i18n';
import Icon from '../icon/icon';

class ProgressBar extends Component {
	render () {
		if (this.props.progressIndex < 0) {
			return null;
		}

		const __ = i18n[this.props.language];

		const progressDot = (stateName, dotIndex) => {
			const dotIsCurrent = this.props.progressIndex === dotIndex;
			const dotIsCompleted = this.props.progressIndex > dotIndex;

			const classNames = classnames({
				'progress-dot-circle': true,
				'progress-dot-checked': dotIsCompleted,
				'progress-dot-complete': (dotIsCompleted || dotIsCurrent),
				'progress-dot-incomplete': (!dotIsCompleted && !dotIsCurrent)
			});

			const labelClassNames = classnames({
				'progress-dot-label': true,
				'progress-dot-label-active': (dotIsCompleted || dotIsCurrent)
			});

			const containerClassNames = classnames({
				'progress-dot-container': true,
				'progress-dot-container-complete': dotIsCompleted
			});

			return (
				<div key={dotIndex} className={containerClassNames}>
					<div className={classNames}>{dotIsCompleted ? <Icon name='MdCheck' align='text-top' /> : (dotIndex + 1)}</div>
					<p className={labelClassNames}>{stateName}</p>
				</div>
			);
		};

		const progressMeter = () => {
			let percentDone = ((this.props.progressIndex + 1) / __.progressStates.length) * 100;
			let meterStyle = { width: `${percentDone}%` };

			return (
				<div className='progress-meter-container'>
					<div className='progress-meter'>
						<div style={meterStyle} className='progress-meter-bar' />
					</div>
					<div className='meter-display'>
						{__.progressMeterDisplay(this.props.progressIndex, __.progressStates)}
					</div>
				</div>
			);
		};

		const containerClassNames = classnames({
			'container': true,
			'lss-progress-bar': true,
			'hidden': this.props.isLoading
		});

		return (
			<div className={containerClassNames}>
				<div className='row hidden-xs visible-sm visible-md visible-lg'>
					<div className='col-xs-8 col-xs-offset-2 lss-progress-bar-desktop'>
						{__.progressStates.map(progressDot)}
					</div>
				</div>
				<div className='row visible-xs hidden-sm hidden-md hidden-lg'>
					<div className='col-xs-12 lss-progress-bar-mobile'>
						{progressMeter()}
					</div>
				</div>
			</div>
		);
	}
}

export default ProgressBar;
